/**
 * Color tokens for the Background-job runner chips (Figma "Admin — Background
 * jobs" 345:2 / run history 359:2). Mirrors the vendorChips pattern: the DSL
 * Chip only supports preset palettes, so these feed the custom `Pill`.
 */

export interface ChipColors {
  label: string;
  bg: string;
  fg: string;
}

const NEUTRAL: ChipColors = { label: '', bg: '#e2e8f0', fg: '#475569' };

// Domain chips — borrow the department-style palette used across the admin.
const DOMAIN_CHIPS: Record<string, ChipColors> = {
  Recipe: { label: 'Recipe', bg: '#fef3c7', fg: '#b45309' },
  Product: { label: 'Product', bg: '#d9dcf0', fg: '#0f25a1' },
  Concept: { label: 'Concept', bg: '#e0e7ff', fg: '#4338ca' },
  Pricing: { label: 'Pricing', bg: '#d6f1d6', fg: '#00aa00' },
  Recall: { label: 'Recall', bg: '#f4d6db', fg: '#bd001f' },
  Inventory: { label: 'Inventory', bg: '#ccfbf1', fg: '#0f766e' },
  User: { label: 'User', bg: '#dddfe0', fg: '#2b343e' },
  Locations: { label: 'Locations', bg: '#e0f2fe', fg: '#0369a1' },
  Catalog: { label: 'Catalog', bg: '#fef9c3', fg: '#854d0e' },
  Maintenance: { label: 'Maintenance', bg: '#e2ddda', fg: '#4a2c1a' },
  Ops: { label: 'Ops', bg: '#f1f5f9', fg: '#475569' },
};

// Per-run status pills (jobs list + history).
const STATUS_CHIPS: Record<string, ChipColors> = {
  success: { label: 'Success', bg: '#dcfce7', fg: '#15803d' },
  failure: { label: 'Failed', bg: '#fee2e2', fg: '#b91c1c' },
  running: { label: 'Running', bg: '#dbeafe', fg: '#1d4ed8' },
  never: { label: 'Never run', bg: '#e2e8f0', fg: '#475569' },
};

const SCHEDULE_CHIPS: Record<string, ChipColors> = {
  cron: { label: 'Cron', bg: '#ede9fe', fg: '#6d28d9' },
  'on-demand': { label: 'On-demand', bg: '#f1f5f9', fg: '#64748b' },
};

export function domainChip(domain: string): ChipColors {
  return DOMAIN_CHIPS[domain] ?? { ...NEUTRAL, label: domain };
}

export function jobStatusChip(status: string): ChipColors {
  return STATUS_CHIPS[status] ?? { ...NEUTRAL, label: status };
}

export function scheduleChip(schedule: string): ChipColors {
  return SCHEDULE_CHIPS[schedule] ?? { ...NEUTRAL, label: schedule };
}
